import { createSelector } from "@reduxjs/toolkit";
import { projectsMapAdapter } from "@store/projects-map/projects-map-slice";
import { getProjectArchivingState } from "@utils/project-utils";

/**
 * @returns all map projects.
 */
const mapProjectsSelector = createSelector(state => state.projectsMap, projectsMapState => {
  return projectsMapAdapter.getSelectors().selectAll(projectsMapState);
});

/**
 * @returns all map projects with the specified archiving state.
 * @param archivingState - The archiving state of the projects to filter by
 */
export function mapProjectsByArchivingStateSelector(archivingState) {
  return createSelector(mapProjectsSelector, projects => {
    return projects.filter(project => {
      const projectArchivingState = getProjectArchivingState(project.archivingState);
      return projectArchivingState === archivingState;
    });
  });
}

/**
 * @returns the fetching status of the map projects
 */
export const mapProjectsFetchingStatusSelector = createSelector(state => state.projectsMap, projectsMapState => projectsMapState.fetchingStatus);